export const bankList = [
	{ label: "Acesso Soluções De Pagamento S.A.", value: "332" },
	{ label: "Advanced Corretora De Câmbio Ltda", value: "117" },
	{ label: "Avista S.A. Crédito", value: "280" },
	{ label: "Agk Corretora De Cambio S.A.", value: "272" },
	{ label: "Al5 S.A. Crédito", value: "349" },
	{ label: "Amazónia Corretora De Câmbio Ltda.", value: "313" },
	{
		label: "Ativa Investimentos S.A. Corretora De Títulos, Câmbio E Valores",
		value: "188"
	},
	{ label: "Avista S.A. Crédito", value: "280" },
	{ label: "B&T Corretora De Cambio Ltda.", value: "080" },
	{ label: "Banco Abc Brasil S.A.", value: "246" },
	{ label: "Banco Abn Amro S.A.", value: "075" },
	{ label: "Banco Agibank S.A.", value: "121" },
	{ label: "Banco Alfa S.A.", value: "025" },
	{ label: "Banco Andbank (Brasil) S.A.", value: "065" },
	{ label: "Banco Arbi S.A.", value: "213" },
	{ label: "Banco B3 S.A.", value: "096" },
	{ label: "Banco Bandepe S.A.", value: "024" },
	{ label: "Banco Bari De Investimentos E Financiamentos S.A.", value: "330" },
	{ label: "Banco BMG S.A.", value: "318" },
	{ label: "Banco Bnp Paribas Brasil S.A.", value: "752" },
	{ label: "Banco Bocom Bbm S.A.", value: "107" },
	{ label: "Banco Bradescard S.A.", value: "063" },
	{
		label: "Banco Bradesco BBI S.A.",
		value: "036"
	},
	{ label: "Banco Bradesco Berj S.A.", value: "122" },
	{ label: "Banco Bradesco Financiamentos S.A.", value: "394" },
	{ label: "Banco Bradesco S.A.", value: "237" },
	{ label: "Banco Bs2 S.A.", value: "218" },
	{ label: "Banco BTG Pactual S.A.", value: "208" },
	{ label: "Banco C6 Consignado S.A.", value: "626" },
	{ label: "Banco C6 S.A.", value: "336" },
	{ label: "Banco Caixa Geral - Brasil S.A.", value: "473" },
	{ label: "Banco Capital S.A.", value: "412" },
	{ label: "Banco Cargill S.A.", value: "040" },
	{ label: "Banco Cedula S.A.", value: "266" },
	{ label: "Banco Cetelem S.A.", value: "739" },
	{ label: "Banco Cetelem S.A.", value: "233" },
	{ label: "Banco Citibank S.A.", value: "745" },
	{ label: "Banco Classico S.A.", value: "241" },
	{
		label: "Banco Cooperativo Do Brasil S.A. - Bancoob - Sicoob",
		value: "756"
	},
	{ label: "Banco Cooperativo Sicredi S.A.", value: "748" },
	{ label: "Banco Crédit Agricole Brasil S.A.", value: "222" },
	{ label: "Banco Credit Suisse (Brasil) S.A.", value: "505" },
	{ label: "Banco Crefisa S.A.", value: "069" },
	{ label: "Banco CSF S.A.", value: "368" },
	{ label: "Banco da Amazonia S.A.", value: "003" },
	{ label: "Banco da China Brasil S.A.", value: "083" },
	{ label: "Banco Daycoval S.A.", value: "707" },
	{ label: "Banco De La Nacion Argentina", value: "300" },
	{ label: "Banco De La Provincia De Buenos Aires", value: "495" },
	{ label: "Banco Digimais S.A.", value: "654" },
	{ label: "Banco Digio S.A.", value: "335" },
	{ label: "Banco do Brasil S.A.", value: "001" },
	{ label: "Banco Do Estado De Sergipe S.A.", value: "047" },
	{ label: "Banco Do Estado Do Pará S.A.", value: "037" },
	{ label: "Banco Do Estado Do Rio Grande Do Sul S.A.", value: "041" },
	{ label: "Banco Do Nordeste Do Brasil S.A.", value: "004" },
	{ label: "Banco Fator S.A.", value: "265" },
	{ label: "Banco Fibra S.A.", value: "224" },
	{ label: "Banco Finaxis S.A.", value: "094" },
	{ label: "Banco Gm S.A.", value: "390" },
	{ label: "Banco Guanabara S.A.", value: "612" },
	{ label: "Banco HSBC S.A.", value: "269" },
	{ label: "Banco Inbursa S.A.", value: "012" },
	{ label: "Banco Industrial Do Brasil S.A.", value: "604" },
	{ label: "Banco Indusval S.A.", value: "653" },
	{ label: "Banco Inter S.A.", value: "077" },
	{ label: "Banco Investcred Unibanco S.A.", value: "249" },
	{ label: "Banco Itaú BBA S.A.", value: "184" },
	{ label: "Banco Itaú Consignado S.A.", value: "029" },
	{ label: "Banco Itaubank S.A.", value: "479" },
	{ label: "Banco J. Safra S.A.", value: "074" },
	{ label: "Banco J.P. Morgan S.A.", value: "376" },
	{ label: "Banco John Deere S.A.", value: "217" },
	{ label: "Banco Kdb Do Brasil S.A.", value: "076" },
	{ label: "Banco Keb Hana Do Brasil S.A.", value: "757" },
	{ label: "Banco Luso Brasileiro S.A.", value: "600" },
	{ label: "Banco Máxima S.A.", value: "243" },
	{ label: "Banco Mercantil do Brasil S.A.", value: "389" },
	{ label: "Banco Mercedes-Benz Do Brasil S.A.", value: "381" },
	{ label: "Banco Mizuho Do Brasil S.A.", value: "370" },
	{ label: "Banco Modal S.A.", value: "746" },
	{ label: "Banco Morgan Stanley S.A.", value: "066" },
	{ label: "Banco Mufg Brasil S.A.", value: "456" },
	{
		label: "Banco Nacional De Desenvolvimento Economico E Social",
		value: "007"
	},
	{ label: "Banco Olé Consignado S.A.", value: "169" },
	{ label: "Banco Original Do Agronegócio S.A.", value: "079" },
	{ label: "Banco Original S.A.", value: "212" },
	{ label: "Banco Ourinvest S.A.", value: "712" },
	{ label: "Banco Pan S.A.", value: "623" },
	{ label: "Banco Paulista S.A.", value: "611" },
	{ label: "Banco Pine S.A.", value: "643" },
	{ label: "Banco Rabobank International Brasil S.A.", value: "747" },
	{ label: "Banco Randon S.A.", value: "088" },
	{ label: "Banco Rendimento S.A.", value: "633" },
	{ label: "Banco Ribeirao Preto S.A.", value: "741" },
	{ label: "Banco Rodobens S.A.", value: "120" },
	{ label: "Banco Safra S.A.", value: "422" },
	{ label: "Banco Santander (Brasil) S.A.", value: "033" },
	{ label: "Banco Semear S.A.", value: "743" },
	{ label: "Banco Sistema S.A.", value: "754" },
	{ label: "Banco Smartbank S.A.", value: "630" },
	{ label: "Banco Societe Generale Brasil S.A.", value: "366" },
	{ label: "Banco Sofisa S.A.", value: "637" },
	{ label: "Banco Sumitomo Mitsui Brasileiro S.A.", value: "464" },
	{ label: "Banco Topázio S.A.", value: "082" },
	{ label: "Banco Toyota Do Brasil S.A.", value: "387" },
	{ label: "Banco Triangulo S.A.", value: "634" },
	{ label: "Banco Tricury S.A.", value: "018" },
	{ label: "Banco Volkswagen S.A.", value: "393" },
	{ label: "Banco Votorantim S.A.", value: "655" },
	{ label: "Banco Vr S.A.", value: "610" },
	{ label: "Banco Western Union Do Brasil S.A.", value: "119" },
	{ label: "Banco Woori Bank Do Brasil S.A.", value: "124" },
	{ label: "Banco Xp S.A.", value: "348" },
	{ label: "Bancoseguro S.A.", value: "081" },
	{ label: "Banestes S.A. Banco Do Estado do Espirito Santo", value: "021" },
	{ label: "Bank of America Merrill Lynch Banco Múltiplo S.A.", value: "755" },
	{ label: "Bari Companhia Hipotecária", value: "268" },
	{ label: "Bbc Leasing S.A. - Arrendamento Mercantil", value: "378" },
	{ label: "Bcv - Banco De Crédito E Varejo S.A.", value: "250" },
	{ label: "Bexs Banco De Câmbio S/A", value: "144" },
	{ label: "Bexs Corretora De Câmbio S/A", value: "253" },
	{
		label: "Bgc Liquidez Distribuidora De Títulos E Valores Mobiliários Ltda",
		value: "134"
	},
	{ label: "Bny Mellon Banco S.A.", value: "017" },
	{ label: "Bónuscred Sociedade De Crédito Direto S.A.", value: "408" },
	{ label: "Bpp Instituição De Pagamento S.A.", value: "301" },
	{ label: "Br Partners Banco De Investimento S.A.", value: "126" },
	{ label: "BrB - Banco De Brasilia S.A.", value: "070" },
	{ label: "Brk S.A. Crédito", value: "092" },
	{
		label: "Brl Trust Distribuidora De Títulos E Valores Mobiliários S.A.",
		value: "173"
	},
	{ label: "Broker Brasil Corretora De Câmbio Ltda.", value: "142" },
	{
		label: "Bs2 Distribuidora De Títulos E Valores Mobiliários S.A.",
		value: "292"
	},
	{ label: "Caixa Economica Federal", value: "104" },
	{ label: "Cambionet Corretora De Câmbio Ltda.", value: "309" },
	{
		label: "Carol Distribuidora De Titulos E Valores Mobiliarios Ltda.",
		value: "288"
	},
	{ label: "Cartos Sociedade De Crédito Direto S.A.", value: "324" },
	{ label: "Caruana S.A. - Sociedade De Crédito", value: "130" },
	{
		label: "Casa Do Crédito S.A. Sociedade De Crédito Ao Microempreendedor",
		value: "159"
	},
	{
		label:
			"Central Cooperativa De Crédito No Estado Do Espírito Santo - Cecoop",
		value: "114"
	},
	{
		label:
			"Central De Cooperativas De Economia E Crédito Mútuo Do Estado Do Rio Grande Do S",
		value: "091"
	},
	{
		label: "China Construction Bank (Brasil) Banco Múltiplo S.A.",
		value: "320"
	},
	{ label: "Cielo S.A.", value: "362" },
	{ label: "Citibank N.A.", value: "477" },
	{
		label:
			"Cm Capital Markets Corretora De Câmbio, Títulos E Valores Mobiliários Ltda",
		value: "180"
	},
	{ label: "Codepe Corretora De Valores E Câmbio S.A.", value: "127" },
	{ label: "Commerzbank Brasil S.A. - Banco Múltiplo", value: "163" },
	{
		label:
			"Banco Cresol - Confederação Nacional Das Cooperativas Centrais De Crédito e Economia Familiar e Solidária",
		value: "133"
	},
	{
		label:
			"Unicred Do Brasil - Confederação Nacional Das Cooperativas Centrais Unicred Ltda.",
		value: "136"
	},
	{ label: "Confidence Corretora De Câmbio S.A.", value: "060" },
	{ label: "Cooperativa Central De Crédito - Ailos", value: "085" },
	{
		label:
			"Cooperativa de Crédito Mutuo dos Despachantes de Trânsito de Santa Catarina e Rio Grande do Sul",
		value: "016"
	},
	{ label: "Cooperativa De Crédito Rural Coopavel", value: "281" },
	{
		label: "Cooperativa De Crédito Rural De Abelardo Luz - Sulcredi/Crediluz",
		value: "322"
	},
	{
		label: "Cooperativa De Credito Rural De Ibiam - Sulcredi/Ibiam",
		value: "391"
	},
	{ label: "Cooperativa De Crédito Rural De Ouro Sulcredi/Ouro", value: "286" },
	{ label: "Cooperativa De Credito Rural De Primavera Do Leste", value: "279" },
	{
		label:
			"Cooperativa De Crédito Rural De São Miguel Do Oeste - Sulcredi/São Miguel",
		value: "273"
	},
	{ label: "Cora Sociedade De Crédito Direto S.A.", value: "403" },
	{ label: "Credialiança Cooperativa De Crédito Rural", value: "098" },
	{ label: "Credicoamo Credito Rural Cooperativa", value: "010" },
	{ label: "Credisan Cooperativa De Crédito", value: "089" },
	{
		label: "Credisis - Central De Cooperativas De Crédito Ltda.",
		value: "097"
	},
	{
		label: "Credit Suisse Hedging-Griffo Corretora De Valores S.A",
		value: "011"
	},
	{ label: "Creditas Sociedade De Crédito Direto S.A.", value: "342" },
	{
		label:
			"Crefaz Sociedade De Crédito Ao Microempreendedor E A Empresa De Pequeno Porte Lt",
		value: "321"
	},
	{ label: "Decyseo Corretora De Cambio Ltda.", value: "289" },
	{ label: "Deutsche Bank S.A. - Banco Alemao", value: "487" },
	{ label: "Easynvest - Título Corretora De Valores Sa", value: "140" },
	{
		label: "Facta Financeira S.A. - Crédito Financiamento e Investimento",
		value: "149"
	},
	{ label: "Fair Corretora De Cambio S.A.", value: "196" },
	{
		label:
			"Ffa Sociedade De Crédito Ao Microempreendedor E À Empresa De Pequeno Porte Ltda.",
		value: "343"
	},
	{
		label: "Fram Capital Distribuidora De Títulos E Valores Mobiliários S.A.",
		value: "331"
	},
	{ label: "Frente Corretora De Câmbio Ltda.", value: "285" },
	{
		label: "Genial Investimentos Corretora De Valores Mobiliários S.A.",
		value: "278"
	},
	{ label: "Gerencianet S.A.", value: "364" },
	{ label: "Get Money Corretora De Câmbio S.A.", value: "138" },
	{
		label:
			"Global Financas - Sociedade De Credito Ao Microempreendedor E A Empresa De Pequeno Porte Ltda",
		value: "384"
	},
	{ label: "Goldman Sachs Do Brasil Banco Multiplo S.A.", value: "064" },
	{ label: "Guide Investimentos S.A. Corretora De Valores", value: "177" },
	{ label: "Guitta Corretora De Cambio Ltda.", value: "146" },
	{ label: "Haitong Banco De Investimento Do Brasil S.A.", value: "078" },
	{ label: "Hipercard Banco Múltiplo S.A.", value: "062" },
	{ label: "HS Financeira S/A Credito", value: "189" },
	{ label: "Hub Pagamentos S.A", value: "396" },
	{
		label: "Ib Corretora De Câmbio, Títulos E Valores Mobiliários S.A.",
		value: "271"
	},
	{
		label: "Icap Do Brasil Corretora De Títulos E Valores Mobiliários Ltda.",
		value: "157"
	},
	{ label: "Icbc Do Brasil Banco Múltiplo S.A.", value: "132" },
	{ label: "Ing Bank N.V.", value: "492" },
	{ label: "Intesa Sanpaolo Brasil S.A. - Banco Múltiplo", value: "139" },
	{ label: "Itaú Unibanco Holding S.A.", value: "652" },
	{ label: "Itaú Unibanco S.A.", value: "341" },
	{ label: "Jpmorgan Chase Bank", value: "488" },
	{ label: "Kirton Bank S.A. - Banco Múltiplo", value: "399" },
	{
		label: "Lastro Rdv Distribuidora De Títulos E Valores Mobiliários Ltda.",
		value: "293"
	},
	{ label: "Lecca Crédito", value: "105" },
	{ label: "Levycam - Corretora De Cambio E Valores Ltda.", value: "145" },
	{ label: "Listo Sociedade De Credito Direto S.A.", value: "397" },
	{
		label: "Magliano S.A. Corretora De Cambio E Valores Mobiliarios",
		value: "113"
	},
	{ label: "Mercadopago.Com Representacoes Ltda.", value: "323" },
	{
		label:
			"Money Plus Sociedade De Crédito ao Microempreendedor e a Empresa De Pequeno Port",
		value: "274"
	},
	{ label: "Moneycorp Banco De Câmbio S.A.", value: "259" },
	{ label: "Ms Bank S.A. Banco De Câmbio", value: "128" },
	{
		label:
			"Necton Investimentos S.A. Corretora de Valores Mobiliários e Commodities",
		value: "354"
	},
	{
		label: "Nova Futura Corretora de Títulos e Valores Mobiliários Ltda.",
		value: "191"
	},
	{ label: "Novo Banco Continental S.A. - Banco Múltiplo", value: "753" },
	{ label: "Nu Pagamentos S.A.", value: "260" },
	{
		label: "Oliveira Trust Distribuidora de Títulos e Valores Mobiliarios S.A.",
		value: "111"
	},
	{
		label: "Om Distribuidora de Títulos e Valores Mobiliários Ltda",
		value: "319"
	},
	{ label: "Omni Banco S.A.", value: "613" },
	{
		label: "Órama Distribuidora de Títulos e Valores Mobiliários S.A.",
		value: "325"
	},
	{ label: "Ótimo Sociedade de Crédito Direto S.A.", value: "355" },
	{ label: "Pagseguro Internet S.A.", value: "290" },
	{ label: "Paraná Banco S.A.", value: "254" },
	{ label: "Parati - Credito", value: "326" },
	{
		label: "Parmetal Distribuidora de Títulos e Valores Mobiliários Ltda",
		value: "194"
	},
	{ label: "Pefisa S.A. - Crédito", value: "174" },
	{
		label: "Pi Distribuidora de Títulos e Valores Mobiliários S.A.",
		value: "315"
	},
	{ label: "Picpay Servicos S.A.", value: "380" },
	{ label: "Planner Corretora de Valores S.A.", value: "100" },
	{ label: "Plural S.A. Banco Múltiplo", value: "125" },
	{ label: "Portocred S.A. - Credito", value: "108" },
	{
		label: "Portopar Distribuidora de Titulos e Valores Mobiliarios Ltda.",
		value: "306"
	},
	{ label: "Qi Sociedade de Crédito Direto S.A.", value: "306" },
	{ label: "Qi Sociedade de Crédito Direto S.A.", value: "329" },
	{
		label:
			"Rb Capital Investimentos Distribuidora de Títulos e Valores Mobiliários Limitada",
		value: "283"
	},
	{ label: "Realize Crédito", value: "374" },
	{
		label: "Renascenca Distribuidora de Títulos e Valores Mobiliários Ltda",
		value: "101"
	},
	{ label: "Sagitur Corretora De Câmbio Ltda.", value: "270" },
	{ label: "Scotiabank Brasil S.A. Banco Múltiplo", value: "751" },
	{ label: "Senff S.A. - Crédito", value: "276" },
	{
		label: "Senso Corretora De Cambio E Valores Mobiliarios S.A",
		value: "545"
	},
	{
		label:
			"Servicoop - Cooperativa De Crédito Dos Servidores Públicos Estaduais Do Rio Gran",
		value: "190"
	},
	{ label: "Socopa Sociedade Corretora Paulista S.A.", value: "363" },
	{
		label:
			"Socred S.A. - Sociedade De Crédito Ao Microempreendedor e a Empresa De Pequeno P",
		value: "183"
	},
	{
		label: "Solidus S.A. Corretora de Cambio e Valores Mobiliarios",
		value: "365"
	},
	{ label: "Sorocred Crédito", value: "299" },
	{ label: "State Street Brasil S.A. - Banco Comercial", value: "014" },
	{ label: "Stone Pagamentos S.A.", value: "197" },
	{ label: "Sumup Sociedade De Crédito Direto S.A.", value: "404" },
	{
		label: "Super Pagamentos e Administração de Meios Eletrônicos S.A.",
		value: "340"
	},
	{
		label:
			"Terra Investimentos Distribuidora de Títulos e Valores Mobiliários Ltda.",
		value: "370"
	},
	{
		label: "Toro Corretora De Títulos E Valores Mobiliários Ltda",
		value: "352"
	},
	{ label: "Travelex Banco De Câmbio S.A.", value: "095" },
	{ label: "Treviso Corretora De Câmbio S.A.", value: "143" },
	{
		label: "Tullett Prebon Brasil Corretora de Valores e Câmbio Ltda",
		value: "131"
	},
	{ label: "Ubs Brasil Banco de Investimento S.A.", value: "129" },
	{
		label: "Ubs Brasil Corretora de Câmbio, Títulos e Valores Mobiliários S.A.",
		value: "015"
	},
	{
		label:
			"Uniprime Central - Central Interestadual De Cooperativas de Credito Ltda.",
		value: "099"
	},
	{
		label:
			"Uniprime Norte Do Paraná - Coop de Economia e Crédito Mútuo Dos Médicos",
		value: "084"
	},
	{ label: "UP.P Sociedade de Empréstimo Entre Pessoas S.A.", value: "373" },
	{ label: "Vip's Corretora de Câmbio Ltda.", value: "298" },
	{ label: "Vision S.A. Corretora De Cambio", value: "296" },
	{
		label: "Vitreo Distribuidora de Títulos e Valores Mobiliários S.A.",
		value: "367"
	},
	{
		label: "Vortx Distribuidora de Titulos e Valores Mobiliarios Ltda.",
		value: "310"
	},
	{
		label:
			"Xp Investimentos Corretora de Câmbio,Títulos d Valores Mobiliários S/A",
		value: "102"
	},
	{ label: "Zema Crédito", value: "359" }
];
